export default function Footer() {
  return (
    <footer className="py-10 border-t border-line">
      <div className="container-narrow flex flex-col sm:flex-row sm:justify-between gap-2 text-sm text-muted">
        <span>© {new Date().getFullYear()} James Yu</span>
        <a href="mailto:j85yu@uwaterloo.ca" className="hover:text-fg transition-colors">
          j85yu@uwaterloo.ca
        </a>
      </div>
    </footer>
  );
}
